import React from 'react'
import Image from 'next/image'

type Props = {
  className?: string
}

export const MainBlockPressLogoImage = ({ className }: Props) => (
  <div className={className}>
    <Image
      src="/img/press/atm-logo@3x.png"
      width="356"
      height="106"
      alt="ATM.com Logo"
    />
  </div>
)
